import {
  MAIN_ROUTES,
  SUB_ROUTES,
} from '@/router/components';
import { BackgroundColors } from '@/@types/types';

const meta = {
  requiresAuth: true,
  hideBreadCrumb: true,
  breadCrumb: 'app.navigation-drawer.dashboard',
  disabled: false,
  background: BackgroundColors.SECONDARY,
  appBar: BackgroundColors.SECONDARY,
};

// Dashboards.vue picks between the historical page and the Vue 3 one (web component) from a
// feature flag. The `tab` segment (`/dashboard/operations`, `/dashboard/pinned`...) belongs to the
// Vue 3 router and is only meaningful when the flag is on. The bare dashboard is an empty child
// path so its URL keeps the trailing slash (`/dashboard/`).
export default {
  path: '/dashboard',
  meta: {
    requiresAuth: true,
    breadCrumb: 'app.navigation-drawer.dashboard',
    disabled: false,
  },
  component: MAIN_ROUTES.DASHBOARD,
  children: [
    {
      path: '',
      name: 'dashboard',
      meta,
      component: SUB_ROUTES.DASHBOARDS,
    },
    {
      path: ':tab',
      name: 'dashboard-tab',
      meta,
      component: SUB_ROUTES.DASHBOARDS,
    },
  ],
};
